

const indexToYears = (result, item, index) => {
  result[index+2020] = (item)
  return result;
}

export const dropdown = [
  "2022", "2025", "2030"
]

// possible values: 'Sparkcity', 'NAL'
export const models = [
   'NAL'
]

export const decielen = {
  NAL: {
    D1: [0,0.0187761607431245,0.0212464855072692,0.0229341115781085,0.0250874071668978,0.0279421484198498,0.0381366422647652,0.0487891763901015,0.0622486691642012,0.0802481685195191,0.103151208316974].reduce(indexToYears, {}), 
    D2: [0,0.020752598716085,0.0251094828722273,0.0283137179976648,0.0321432404325878,0.0369557446843174,0.0485375447006103,0.0575983332383143,0.0748308469739866,0.0906027709091343,0.120343076369803].reduce(indexToYears, {}), 
    D3: [0,0.0335994455403281,0.0395957229908199,0.045868223156217,0.0509587958077612,0.0631478462992574,0.0762732845295306,0.0901244508317155,0.106617401440813,0.133962668415649,0.169935003445271].reduce(indexToYears, {}), 
    D4: [0,0.0365641024997688,0.0434587203557779,0.0509646923957966,0.0572306475994856,0.0695335835654745,0.0797402520081455,0.0982559802300655,0.119199579250598,0.142375782857211,0.181175840249043].reduce(indexToYears, {}), 
    D5: [0,0.0503991683104922,0.0627737071805681,0.0679529231943955,0.0736942585527623,0.0815955317349955,0.100542056879836,0.121972940975254,0.148337254178522,0.184441355065023,0.218865704826399].reduce(indexToYears, {})
  }
}





